// utils/rowCalculators.js

export const costCategoryCalculator = {
  1: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[0]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[0]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const pipelineLength = parseFloat(formData.quantities?.[6]?.quantity) || 0;
    const rate = parseFloat(formData.averageROWCostPerFoot) || 0;

    let price = rate * pipelineLength * 5280;
    price = Math.round(price);

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },

  2: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[1]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[1]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const milesOfRoadRaw = formData.quantities?.[10]?.quantity;
    const accessRoadPricing = parseFloat(rowPricing?.[11]?.price || 0);

    const milesOfRoad = milesOfRoadRaw === '' || milesOfRoadRaw == null ? 0 : parseFloat(milesOfRoadRaw);

    const price = milesOfRoad * accessRoadPricing;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  3: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[2]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[2]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const boreClass1 = formData.quantities?.[12]?.quantity;
    const boreClass2 = formData.quantities?.[14]?.quantity;
    const boreClass3 = formData.quantities?.[16]?.quantity;
    const tempSitePricing = parseFloat(rowPricing?.[2]?.price || 0);

    const price = (boreClass1 + boreClass2 + boreClass3) * tempSitePricing;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  4: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[3]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[3]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const tracCount = formData.quantities?.[11]?.quantity;
    const rowAgentFees = parseFloat(rowPricing?.[10]?.price || 0);

    const price = tracCount * rowAgentFees;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  5: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[4]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[4]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const tracCount = formData.quantities?.[11]?.quantity;
    const titleAgentFees = parseFloat(rowPricing?.[4]?.price || 0);

    const price = tracCount * titleAgentFees;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  6: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[5]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[5]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const preliminarySurvey = parseFloat(rowPricing?.[3]?.price || 0);

    const price = routeLenght * preliminarySurvey;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  7: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[6]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[6]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const platsCost = parseFloat(rowPricing?.[12]?.price || 0);

    const price = routeLenght * platsCost;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  8: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[7]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[7]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const asBuiltInSurvey = parseFloat(rowPricing?.[13]?.price || 0);

    const price = routeLenght * asBuiltInSurvey;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  9: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[8]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[8]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const bioSurvey = parseFloat(rowPricing?.[0]?.price || 0);

    const price = routeLenght * bioSurvey;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  10: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[9]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[9]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const archSurvey = parseFloat(rowPricing?.[5]?.price || 0);

    const price = routeLenght * archSurvey;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  11: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[10]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[10]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const classLocation = parseFloat(rowPricing?.[1]?.price || 0);

    const price = routeLenght * classLocation;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  12: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[11]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[11]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const routeLenght = formData.quantities?.[5]?.quantity;
    const swpp = parseFloat(rowPricing?.[14]?.price || 0);

    const price = routeLenght * swpp;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: overrideOrPrice,
      totalPrice: totalCost,
      taxRate: '-',
      taxCost: '-',
    };
  },
  15: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[14]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[14]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const hiddenClass1Price = formData?.hiddenPipeCostCalc?.[0]?.cost;

    const price = hiddenClass1Price;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  16: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[15]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[15]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    let totalHiddenHeavyWallPrice = 0;

    for (let i = 1; i <= 8; i++) {
      const cost = parseFloat(formData?.hiddenPipeCostCalc?.[i]?.cost);
      if (!isNaN(cost)) {
        totalHiddenHeavyWallPrice += cost;
      }
    }

    const price = totalHiddenHeavyWallPrice;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  17: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[16]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[16]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const hiddenClass1Price = formData?.hiddenPipeCostCalc?.[0]?.cost;

    const price = hiddenClass1Price * 0.03 || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  18: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[17]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[17]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();

    const valveRow = componentPricing?.[3];
    const matchedValve = valveRow?.[pipeODQuantity];

    const mainlineValvePrice = matchedValve?.price ?? 0;

    const mainValQuantiy = formData.quantities?.[34]?.quantity?.toString();

    const price = mainlineValvePrice * mainValQuantiy || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  19: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[18]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[18]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();

    const futureRow = componentPricing?.[4];
    const matchedFuture = futureRow?.[pipeODQuantity];

    const futureTapPrice = matchedFuture?.price ?? 0;

    const futureTapQuantiy = formData.quantities?.[35]?.quantity?.toString();

    const price = futureTapPrice * futureTapQuantiy || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  20: (row, formData, rowPricing, componentPricing) => {
    const pmOverrideRaw = formData.costCategory?.[19]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[19]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();

    const lrSetRow = componentPricing?.[1];
    const matchedLrSet = lrSetRow?.[pipeODQuantity];

    const lrSetPrice = matchedLrSet?.price ?? 0;

    const lrSetQuantiy = formData.quantities?.[36]?.quantity?.toString();

    const price = lrSetPrice * lrSetQuantiy || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  21: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[20]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[20]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();

    const cpTestStationsQty = formData.quantities?.[38]?.quantity?.toString();
    const miscCosts = miscPricing?.[1]?.price;

    const price = cpTestStationsQty * miscCosts || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  22: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[21]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[21]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const price = pmOverrideRaw;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  23: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[22]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[22]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const price = pmOverrideRaw;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  24: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing) => {
    const pmOverrideRaw = formData.costCategory?.[23]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[23]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const length3d = formData.quantities?.[3]?.quantity;
    const pipeODQuantity = formData.quantities?.[0]?.quantity;

    const lineFillPrice = lineFillPricing?.[1]?.price;
    let baseQtySum = 0;

    for (let i = 0; i <= 7; i++) {
      const qty = parseFloat(formData?.pipeSpecs?.[i]?.baseQty);
      if (!isNaN(qty)) {
        baseQtySum += qty;
      }
    }

    const price =
      (((baseQtySum / (length3d / 20)) * 12 * (Math.PI * Math.pow(pipeODQuantity / 2, 2)) * 0.004321) / 42) *
      lineFillPrice;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  25: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[24]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[24]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const length3d = formData.quantities?.[3]?.quantity;
    const pipelineMarkersPrice = miscPricing?.[0]?.price;

    const price = pipelineMarkersPrice * 5 * length3d;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  26: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing) => {
    const product = formData?.quantities?.[1]?.quantity;

    const productType = product === 1 ? 'Natural Gas' : product === 2 ? 'NGL' : 'Other';

    const MAOP = formData?.quantities?.[8]?.quantity; // Gauge pressure
    const wallThickness = formData?.pipeSpecs?.[1]?.wallThickness; // Gauge pressure

    const lineFillPrice = lineFillPricing?.[2]?.price; // Rate per MCF for Natural Gas
    const lineNglPrice = lineFillPricing?.[3]?.price; // Rate per MCF for Natural Gas

    const pmOverrideRaw = formData.costCategory?.[25]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[25]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const pipelineLength = parseFloat(formData.quantities?.[3]?.quantity) || 1;
    const pipeODQuantity = parseFloat(formData.quantities?.[0]?.quantity) || 0;

    let calculatedPrice = 0;

    if (productType === 'Natural Gas') {
      const internalDiameter = (pipeODQuantity - 2 * wallThickness) / 12; // inches to feet
      const radius = internalDiameter / 2;

      calculatedPrice =
        (((MAOP + 14.7) * (Math.PI * Math.pow(radius, 2) * (pipelineLength * 5280))) / 1000 / 14.7) *
        lineFillPrice *
        1.05;
    } else {
      const radius = pipeODQuantity / 2;
      calculatedPrice = (12 * (Math.PI * Math.pow(radius, 2)) * 0.004321 * pipelineLength * lineNglPrice) / 42;
    }

    // Apply override if available
    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? calculatedPrice : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price: calculatedPrice,
      contingencyPercent,
      contingencyCost,
      baseCost,
      totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  27: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[26]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[26]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    const price = pmOverrideRaw;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  28: (row, formData, rowPricing, componentPricing, miscPricing) => {
    const pmOverrideRaw = formData.costCategory?.[27]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[27]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;

    let sumOfValues = 0;

    for (let i = 14; i <= 20; i++) {
      const price = parseFloat(formData?.costCategory?.[i]?.price);
      if (!isNaN(price)) {
        sumOfValues += price;
      }
    }
    const price = sumOfValues * 0.06 || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const baseCost = overrideOrPrice + contingencyCost;
    const totalPrice = baseCost + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: baseCost,
      totalPrice: totalPrice,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  30: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[29]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[29]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const length3d = formData.quantities?.[3]?.quantity;

    const baseLayPricing = constructionPricing?.[8];
    const matchedValve = baseLayPricing?.[pipeODQuantity];

    const baseLayPrice = matchedValve?.price ?? 0;

    const price = baseLayPrice * length3d * 5280 || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  31: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[30]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[30]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const lengthBore1 = formData.quantities?.[13]?.quantity;
    const lengthBore2 = formData.quantities?.[15]?.quantity;
    const lengthBore3 = formData.quantities?.[17]?.quantity;
    const sumOfBores = lengthBore1 + lengthBore2 + lengthBore3 || 0;

    const borePerFtPricing = constructionPricing?.[0];
    const matchedValve = borePerFtPricing?.[pipeODQuantity];

    const borePerFtPricingPrice = matchedValve?.price ?? 0;

    const price = borePerFtPricingPrice * sumOfBores || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  32: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[31]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[31]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const directPipeQty = formData.quantities?.[20]?.quantity;

    const directPipePricing = constructionPricing?.[6];
    const matchedValve = directPipePricing?.[pipeODQuantity];

    const directPipePrice = matchedValve?.price ?? 0;

    const price = directPipePrice * directPipeQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  33: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[32]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[32]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const lengthHddQty = formData.quantities?.[19]?.quantity;

    const horizontalDrillPricing = constructionPricing?.[12];
    const matchedValve = horizontalDrillPricing?.[pipeODQuantity];

    const horizontalDrillPrice = matchedValve?.price ?? 0;

    const price = horizontalDrillPrice * lengthHddQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  34: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[33]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[33]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const rockDitchQty = formData.quantities?.[28]?.quantity;

    const rockDitchPricing = constructionPricing?.[15];
    const matchedValve = rockDitchPricing?.[pipeODQuantity];

    const rockDitchPrice = matchedValve?.price ?? 0;

    const price = rockDitchPrice * rockDitchQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  35: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[34]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[34]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const pigTrapQty = formData.quantities?.[36]?.quantity;

    const installTrailPricing = constructionPricing?.[9];
    const matchedValve = installTrailPricing?.[pipeODQuantity];

    const installTrailPrice = matchedValve?.price ?? 0;

    const price = installTrailPrice * pigTrapQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  36: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[35]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[35]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const mainValvesQty = formData.quantities?.[34]?.quantity;

    const mainValvePricing = constructionPricing?.[13];
    const matchedValve = mainValvePricing?.[pipeODQuantity];

    const mainValvePrice = matchedValve?.price ?? 0;

    const price = mainValvePrice * mainValvesQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  37: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[36]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[36]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const futureTapQty = formData.quantities?.[35]?.quantity;

    const tapValvePricing = constructionPricing?.[4];
    const matchedValve = tapValvePricing?.[pipeODQuantity];

    const tapValvePrice = matchedValve?.price ?? 0;

    const price = tapValvePrice * futureTapQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  38: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[37]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[37]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const pigBarrelsQty = formData.quantities?.[37]?.quantity;

    const fabricationPricing = constructionPricing?.[3];
    const matchedValve = fabricationPricing?.[pipeODQuantity];

    const fabricationPrice = matchedValve?.price ?? 0;

    const price = fabricationPrice * pigBarrelsQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  39: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[38]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[38]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const foreignLineCrossingQty = formData.quantities?.[26]?.quantity;

    const foreignLineCrossingPricing = constructionPricing?.[5];
    const matchedValve = foreignLineCrossingPricing?.[pipeODQuantity];

    const foreignLineCrossingPrice = matchedValve?.price ?? 0;

    const price = foreignLineCrossingPrice * foreignLineCrossingQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },

  40: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    const pmOverrideRaw = formData.costCategory?.[39]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[39]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const matsQty = formData.quantities?.[32]?.quantity;

    const matsPricing = constructionPricing?.[1];
    const matchedValve = matsPricing?.[pipeODQuantity];

    const matsPrice = matchedValve?.price ?? 0;

    const price = matsPrice * matsQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
  41: (row, formData, rowPricing, componentPricing, miscPricing, lineFillPricing, constructionPricing) => {
    console.log(constructionPricing);

    const pmOverrideRaw = formData.costCategory?.[40]?.pmOverride;
    const contigencyOverrideRaw = formData.costCategory?.[40]?.contOverridePercent?.replace('%', '');
    const contingencyPercentRaw = formData.costAssumptions?.[2]?.value;
    const pipeODQuantity = formData.quantities?.[0]?.quantity?.toString();
    const hotTapQty = formData.quantities?.[41]?.quantity;

    const hotTapPricing = constructionPricing?.[14];
    const matchedValve = hotTapPricing?.[pipeODQuantity];

    const hotTapPrice = matchedValve?.price ?? 0;

    const price = hotTapPrice * hotTapQty || 0;

    const overrideOrPrice = pmOverrideRaw === '' || pmOverrideRaw == null ? price : parseFloat(pmOverrideRaw);

    const contingencyPercent =
      contigencyOverrideRaw !== '' && contigencyOverrideRaw != null
        ? parseFloat(contigencyOverrideRaw)
        : contingencyPercentRaw !== '' && contingencyPercentRaw != null
          ? parseFloat(contingencyPercentRaw)
          : 0;

    const contingencyCost = overrideOrPrice * (contingencyPercent / 100);
    const totalCost = overrideOrPrice + contingencyCost;

    return {
      price,
      contingencyPercent,
      contingencyCost,
      baseCost: price,
      totalPrice: totalCost,
      taxRate: contingencyPercent,
      taxCost: contingencyCost,
    };
  },
};
